import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M25.3337 17.3334H17.3337V25.3334H14.667V17.3334H6.66699V14.6667H14.667V6.66675H17.3337V14.6667H25.3337V17.3334Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 6,
			y: 6,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M25.3337 17.3334H17.3337V25.3334H14.667V17.3334H6.66699V14.6667H14.667V6.66675H17.3337V14.6667H25.3337V17.3334Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
